import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-navigation-logged-out-home-section-resources',
  template: `
    <app-navigation-logged-out-home-list
      [list]="resourcesList"
      [marginBottomTablet]="'xxsmall'"
    >
    </app-navigation-logged-out-home-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLoggedOutHomeSectionResourcesComponent {
  resourcesList = [
    {
      linkDescription: $localize`What Is Adobe Photoshop`,
      linkUrl: '/what-is-adobe-photoshop',
    },
    {
      linkDescription: $localize` What Is Android App Development `,
      linkUrl: '/what-is-android-app-development',
    },
    {
      linkDescription: $localize` What Is Article Writing `,
      linkUrl: '/what-is-article-writing',
    },
    {
      linkDescription: $localize` What Is Data Entry `,
      linkUrl: '/what-is-data-entry-guide',
    },
    {
      linkDescription: $localize`What Is Graphic Design`,
      linkUrl: '/what-is-graphic-design-about',
    },
    {
      linkDescription: $localize`What Is HTML`,
      linkUrl: '/what-is-html',
    },
    {
      linkDescription: $localize`What Is Internet Marketing`,
      linkUrl: '/what-is-internet-marketing',
    },
    {
      linkDescription: $localize`What Is iPhone App Development`,
      linkUrl: '/what-is-iphone-app-development',
    },
    {
      linkDescription: $localize`What Is JavaScript`,
      linkUrl: '/what-is-javascript',
    },
    {
      linkDescription: $localize`What Is Logo Design`,
      linkUrl: '/what-is-logo-design',
    },
    {
      linkDescription: $localize`What Is Mobile App Development`,
      linkUrl: '/what-is-mobile-application-development',
    },
    {
      linkDescription: $localize`What Is PHP`,
      linkUrl: '/what-is-php',
    },
    {
      linkDescription: $localize`What Is Python`,
      linkUrl: '/what-is-python',
    },
    {
      linkDescription: $localize`What Is Software Architecture`,
      linkUrl: '/what-is-software-architecture',
    },
    {
      linkDescription: $localize`What Is Web Design`,
      linkUrl: '/what-is-web-design',
    },
    {
      linkDescription: $localize`What Is Wordpress`,
      linkUrl: '/what-is-wordpress',
    },
  ];
}
